var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.associatedHazards.length > 0
    ? _c("div", { staticClass: "associated-associatedHazards" }, [
        _c("h2", { staticClass: "t-orange text-center mb-3" }, [
          _vm._v("Associated Hazards")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "uxo-list columns is-multiline is-mobile mb-5" },
          [
            _vm._l(_vm.associatedHazards, function(associatedHazard) {
              return [
                _c(
                  "div",
                  { staticClass: "column is-4-mobile is-2-tablet mb-1" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "uxo-list__item",
                        attrs: { href: associatedHazard.url }
                      },
                      [
                        associatedHazard.images[0]
                          ? _c("img", {
                              staticClass: "image mb-1",
                              attrs: {
                                src: associatedHazard.images[0].aws_url,
                                alt: associatedHazard.name
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h5", { staticClass: "font-weight-normal" }, [
                          _vm._v(_vm._s(associatedHazard.name))
                        ])
                      ]
                    )
                  ]
                )
              ]
            })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40f25260", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40f25260","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/AssociatedHazards.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-40f25260","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/AssociatedHazards.vue
// module chunks = 0 1